import type { CommonAction } from "@iflyrpa/share";
import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";
import { executeAction } from "../../utils";
import { mockAction } from "./mock";
import { rpaAction } from "./rpa";
import { rpaAction_Server } from "./rpa-server";

export const ShipinhaoPublishParamsSchema = ActionCommonParamsSchema.extend({
    title: z.string(), // 标题
    content: z.string(), // 正文
    banners: z.array(z.string()), // 图片URL字符串数组
    topic: z.array(z.string()).optional(), // 话题
    address: z
        .object({
            poi_id: z.string(), // uid
            name: z.string().optional(), // name
            address: z.string().optional(), // fullAddress
            latitude: z.number(),
            longitude: z.number(),
            city_name: z.string(), // city
        })
        .optional(), // 位置，不显示位置则不传此参数
    link: z
        .object({
            // 链接
            urlType: z.number(), // 公众号文章 1 红包封面 2
            link: z.string(),
            title: z.string(), // 链接校验成功时data中的返回值title
        })
        .optional(),
    collection: z
        .object({
            // 合集
            collectionId: z.string(), // 合集id
            collectionName: z.string(), //合集名称
        })
        .optional(),
    music: z
        .object({
            id: z.string(), // musicSid 或 playableInfo.listenId
            name: z.string(), // playableInfo.title
            image: z.string(), // playableInfo.cover
            authorName: z.string(), // playableInfo.author
            url: z.string(), // url
            raw: z.object({
                playableInfo: z.object({
                    type: z.number(), // playableInfo.type
                }),
                bgmSource: z.number(), // BGM来源 搜索-4 推荐-2 其他-1
                query: z.string().optional(), // 搜索查询的字符串
            }),
        })
        .optional(), // 音乐信息
    proxyLoc: z.string().optional(), // 代理位置
    localIP: z.string().optional(), // 用户ip
    isImmediatelyPublish: z.boolean().optional(), // 是否立即发布
    scheduledPublish: z.number().optional(), // 定时发布时间，时间戳类型 10位数字
    publishType: z.enum(["1", "2"]).optional(), // 发布类型 1：发布 2：同步
});

export type ShipinhaoPublishParams = z.infer<typeof ShipinhaoPublishParamsSchema>;

export type PublishAction = CommonAction<ShipinhaoPublishParams, string>;

export const shipinhaoPublish: PublishAction = async (task, params) => {
    task.logger.info(`shipinhaoPublish actionType: ${params.actionType}`);
    if (params.actionType === "rpa") {
        return rpaAction(task, params);
    }

    if (params.actionType === "mockApi") {
        return mockAction(task, params);
    }

    if (params.actionType === "server") {
        return rpaAction_Server(task, params);
    }

    return executeAction(mockAction, rpaAction_Server)(task, params);
};
